import TouchableOpacity from '../TouchableOpacity'
import styles from './style'

interface AddInstanceProps {
  onClick?: () => void
}

function AddInstance({ onClick: handleOnPress = () => {} }: AddInstanceProps) {
  return (
    <TouchableOpacity
      onClick={handleOnPress}
      style={styles.root}
    >
      <div style={styles.row}>
        <div style={styles.line} />+
        <div style={styles.line} />
      </div>
    </TouchableOpacity>
  )
}

export default AddInstance
